export const LOGIN_TYPE_PARAM_KEY = 'loginType';
export const LOGIN_TYPE_PARAM_VALUE = 'activated';
